/**
 * API bazı alanlarda renk için hex yerine semantik ad gönderiyor
 * (ör. cart_box'ta `color: "success"`, color_hex yok). Karşılığı yoksa
 * satır varsayılan renkte kalıyordu — bu tablo ikisini birleştiriyor.
 * Değerler API'nin banner/label alanlarında gönderdiği hex'lerle aynı.
 */
const SEMANTIC_COLOR_HEX: Record<string, string> = {
  success: "#059669",
  danger: "#dc3545",
  error: "#dc3545",
  warning: "#F59E0B",
  info: "#3B82F6",
};

/**
 * Önce hex'i kullan; yoksa semantik adı hex'e çevir. İkisi de yoksa undefined.
 */
export const resolveColorHex = (
  colorHex?: string,
  colorName?: string,
): string | undefined => {
  if (colorHex) return colorHex;
  if (!colorName) return undefined;
  return SEMANTIC_COLOR_HEX[colorName.toLowerCase()];
};

/**
 * Converts hex color to soft background color with proper text contrast
 * @param hexColor - Hex color string (e.g., "#2114ae" or "#2114aeff")
 * @returns Object with background and text colors
 */
export const getSoftBadgeColors = (hexColor: string): { bg: string; text: string } => {
  // Remove # if present and alpha channel if exists
  const hex = hexColor.replace('#', '').substring(0, 6);
  
  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Create soft background (15% opacity)
  const bgColor = `rgba(${r}, ${g}, ${b}, 0.15)`;
  
  // Use original color for text
  const textColor = `rgb(${r}, ${g}, ${b})`;
  
  return {
    bg: bgColor,
    text: textColor,
  };
};

/**
 * Get badge style object for inline styles
 * Direct hex color from API can be used with backgroundColor
 * @param hexColor - Hex color string from API
 * @returns Style object with backgroundColor
 */
export const getBadgeStyle = (hexColor: string): React.CSSProperties => {
  return {
    backgroundColor: hexColor,
    color: '#ffffff', // White text for better contrast
  };
};

/**
 * Get soft badge style (with opacity) for inline styles
 * @param hexColor - Hex color string from API
 * @returns Style object with soft backgroundColor and original color text
 */
export const getSoftBadgeStyle = (hexColor: string): React.CSSProperties => {
  const colors = getSoftBadgeColors(hexColor);
  return {
    backgroundColor: colors.bg,
    color: colors.text,
  };
};
